(function () {
  const U = window.UIX;
  const APP = window.APP;

  const el = U.el;
  const esc = U.esc;
  const menuCfg = U.menuCfg;
  const saveMenuCfg = U.saveMenuCfg;

  const TRAINER_START_KEY = "riftbound-trainer-start";
  const RUNE_TOTAL = U.RUNE_TOTAL;
  const FIELD_TOTAL = U.FIELD_TOTAL;
  const CURVE_BARS = U.CURVE_BARS;
  const deckCurve = U.deckCurve;
  const peakOf = U.peakOf;

  const ACCENT = {
    fury: ["#ff7b6b", "#ffd4cc", "#b8483c", "#7a3a30", "M12 8.6l3.4 5.9H8.6z"],
    calm: ["#7bd88f", "#d3f5da", "#3f9455", "#2c4a3a", "M12 8.9a3.1 3.1 0 1 0 0 6.2 3.1 3.1 0 0 0 0-6.2z"],
    mind: ["#6bb7ff", "#cbe6ff", "#3574b5", "#26405a", "M12 8.5l3.5 3.5-3.5 3.5L8.5 12z"],
    body: ["#ffab5e", "#ffdfbe", "#b8722f", "#5a3e1c", "M8.4 10.4h7.2v3.2H8.4z"],
    chaos: ["#c98bff", "#e8d3ff", "#8a4fbb", "#46305a", "M12 7.8l1.2 3 3 1.2-3 1.2-1.2 3-1.2-3-3-1.2 3-1.2z"],
    order: ["#ffe95e", "#fff8c9", "#b8a32c", "#5a531c", "M12 8.4l3.1 1.8v3.6L12 15.6l-3.1-1.8v-3.6z"],
  };
  const REMOTE_ACCENT = { claude: "chaos", online: "mind" };

  const ICO = {
    back: "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2.2' stroke-linecap='round' stroke-linejoin='round'><path d='M14 6l-6 6 6 6'></path></svg>",
    seal: "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.2'><path d='M12 2l8.7 5v10L12 22l-8.7-5V7z'></path><circle cx='12' cy='12' r='3.4'></circle><path d='M12 5.4v3.2M12 15.4v3.2M6.3 8.7l2.8 1.6M14.9 13.7l2.8 1.6M17.7 8.7l-2.8 1.6M9.1 13.7l-2.8 1.6'></path></svg>",
    book: "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.5'><path d='M7.5 4.5h9v15h-9z'></path><path d='M4.6 7.2L3 7.7l3.2 11.6 1.6-.5'></path><path d='M19.4 7.2L21 7.7l-3.2 11.6-1.6-.5'></path></svg>",
    swap: "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M4 9h13l-3.4-3.6M20 15H7l3.4 3.6'></path></svg>",
    pencil: "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.7' stroke-linejoin='round'><path d='M4 20h4l10-10-4-4L4 16z'></path><path d='M14.6 5.4l4 4'></path></svg>",
    copy: "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.6'><path d='M9 9h10v11H9z'></path><path d='M6 15H5V4h10v1'></path></svg>",
    dice: "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.6'><path d='M4.6 4.6h14.8v14.8H4.6z'></path><circle cx='9' cy='9' r='1.15' fill='currentColor' stroke='none'></circle><circle cx='15' cy='9' r='1.15' fill='currentColor' stroke='none'></circle><circle cx='12' cy='12' r='1.15' fill='currentColor' stroke='none'></circle><circle cx='9' cy='15' r='1.15' fill='currentColor' stroke='none'></circle><circle cx='15' cy='15' r='1.15' fill='currentColor' stroke='none'></circle></svg>",
    openYou: "<svg viewBox='0 0 24 16' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M19 8H5M11 2L5 8l6 6'></path></svg>",
    openFoe: "<svg viewBox='0 0 24 16' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M5 8h14M13 2l6 6-6 6'></path></svg>",
    warn: "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.8' stroke-linecap='round'><path d='M12 4.4l9 15.2H3z'></path><path d='M12 10v4.2M12 16.6v.6'></path></svg>",
    go: "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2.4' stroke-linecap='round' stroke-linejoin='round'><path d='M6 5l7 7-7 7M14 5l6 7-6 7'></path></svg>",
  };

  const MODES = {
    ai: ["AI", "Heuristic pilot, instant moves",
      "M12 3v3.2M12 17.8V21M3 12h3.2M17.8 12H21", "M5.6 5.6l2.3 2.3M16.1 16.1l2.3 2.3M18.4 5.6L16.1 7.9M7.9 16.1l-2.3 2.3"],
    native: ["Search", "The native search player — set its budget in this pane",
      "M12 3.4v3.4M6.6 10.6v3M17.4 10.6v3", "M12 6.8L6.6 10.6M12 6.8l5.4 3.8M6.6 13.6L4.2 17M6.6 13.6L9 17M17.4 13.6L15 17M17.4 13.6l2.4 3.4"],
    claude: ["Claude", "An agent seat, driven over a URL you hand to Claude Code",
      "M3.4 5.4h17.2v13.2H3.4z", "M7 10l2.6 2.4L7 14.8M12.6 15.2h4.2"],
    online: ["Online", "A person over the network",
      "M9 6.2a2.8 2.8 0 1 0 0 5.6 2.8 2.8 0 0 0 0-5.6zM3.6 19c0-2.9 2.4-4.8 5.4-4.8s5.4 1.9 5.4 4.8", "M17 5.8a2.2 2.2 0 1 0 0 4.4 2.2 2.2 0 0 0 0-4.4zM15.8 13.2c2.9-.3 4.6 1.7 4.6 4.2"],
  };

  function lobby() { return RB.Online.Lobby; }
  function lobbyInfo() { return RB.Online.Lobby.S.info; }
  function nameOk() { return !!RB.Online.playerName().trim(); }
  function myName() { return RB.Online.playerName().trim() || "Unnamed"; }
  const BOT_POWERS = [["claude", "Claude", "Claude plays every move itself, through the same seat tools as /play", "Plays every move"],
    ["claude-jev", "Claude + Jev", "Claude writes a plan each turn and Jev picks every action", "Claude plans · Jev acts"],
    ["jev", "Jev alone", "Jev picks every action with no planner", "No planner"],
    ["ai", "AI", "The heuristic pilot", "Heuristic pilot"],
    ["native", "Search", "The native search player", "Native search"]];
  const ARENA_HINT = "Both sides play themselves in one arena game, and you watch it live. Claude runs on your Claude Code subscription; Jev costs about 4 cents a game on OpenRouter.";
  const BOT_MODELS = ["haiku", "sonnet", "opus"];

  function botKeys() { return BOT_POWERS.map(function (p) { return p[0]; }); }
  function botMode(cfg) { return botKeys().indexOf(cfg.pilot) >= 0; }
  function usesClaude(power) { return power === "claude" || power === "claude-jev"; }
  function foePower(cfg) { return botKeys().indexOf(cfg.foeBot) >= 0 ? cfg.foeBot : "claude-jev"; }
  function modelOf(v) { return BOT_MODELS.indexOf(v) >= 0 ? v : "haiku"; }
  function isLocal(cfg) { return botMode(cfg) || cfg.foe === "ai" || cfg.foe === "native"; }

  function botSeg(current, withYou, onPick) {
    const seg = el("span", "plseg");
    const rows = (withYou ? [["you", "You", "You play this side"]] : []).concat(BOT_POWERS);
    for (const row of rows) {
      (function (row) {
        const b = el("button", "plsegb" + (current === row[0] ? " on" : ""), esc(row[1]));
        b.type = "button";
        b.title = row[2];
        b.onclick = function () { onPick(row[0]); };
        seg.appendChild(b);
      })(row);
    }
    return seg;
  }

  function modelSeg(current, onPick) {
    const seg = el("span", "plseg");
    for (const m of BOT_MODELS) {
      (function (m) {
        const b = el("button", "plsegb" + (current === m ? " on" : ""), esc(m.charAt(0).toUpperCase() + m.slice(1)));
        b.type = "button";
        b.title = "The Claude model for this side, on your Claude Code subscription";
        b.onclick = function () { onPick(m); };
        seg.appendChild(b);
      })(m);
    }
    return seg;
  }

  function botWho(power) {
    const row = BOT_POWERS.filter(function (p) { return p[0] === power; })[0];
    const who = el("div", "plwho");
    who.title = row[2];
    who.appendChild(el("span", "plwhon", esc(row[1])));
    who.appendChild(el("span", "plwhotag", esc(row[3])));
    return who;
  }

  function arenaJob() {
    if (APP.arenaJob === undefined) {
      APP.arenaJob = null;
      fetch("/api/arena/job").then(function (r) { return r.ok ? r.json() : null; }).then(function (st) {
        APP.arenaJob = st && st.running ? st : false;
        if (APP.arenaJob) U.render();
      }).catch(function () { APP.arenaJob = false; });
    }
    return APP.arenaJob || null;
  }

  function stopArena() {
    const job = APP.arenaJob;
    if (!job || job.stopping) return;
    job.stopping = true;
    U.render();
    fetch("/api/arena/job/stop", { method: "POST" }).then(function (r) { return r.json(); }).then(function () {
      APP.arenaJob = false;
      APP.arenaLaunch = null;
      U.render();
    }).catch(function () { job.stopping = false; U.render(); });
  }

  function startArena(cfg) {
    if (APP.arenaLaunch && APP.arenaLaunch.busy) return;
    APP.arenaLaunch = { busy: true, err: null };
    U.render();
    const fail = function (msg) { APP.arenaLaunch = { busy: false, err: msg }; U.render(); };
    fetch("/api/arena/job", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ seats: [
        { power: cfg.pilot, model: modelOf(cfg.pilotModel), deck: cfg.seats[0].deck },
        { power: foePower(cfg), model: modelOf(cfg.foeModel), deck: cfg.seats[1].deck },
      ] }),
    }).then(function (r) { return r.json(); }).then(function (j) {
      if (j.error) {
        if (j.gameId) { location.href = "/watch?game=" + encodeURIComponent(j.gameId); return; }
        return fail(j.error);
      }
      let tries = 0;
      const wait = function () {
        fetch("/api/arena/replays/" + encodeURIComponent(j.gameId)).then(function (r) {
          if (r.ok) { location.href = "/watch?game=" + encodeURIComponent(j.gameId); return; }
          return fetch("/api/arena/job").then(function (r2) { return r2.json(); }).then(function (st) {
            if (!st.running) return fail("The arena stopped before the game began. " + String(st.tail || "").trim().split("\n").slice(-2).join(" "));
            if (++tries > 60) return fail("The game did not start within a minute.");
            setTimeout(wait, 1000);
          });
        }).catch(function () { fail("The arena feed did not answer."); });
      };
      wait();
    }).catch(function () { fail("The server did not answer. Arena games need the local tools enabled."); });
  }

  function accentKey(deck) {
    const doms = deck ? U.deckDomains(deck) : [];
    return doms.length && ACCENT[doms[0]] ? doms[0] : "mind";
  }

  function tint(sideLetter, key) {
    const a = ACCENT[key] || ACCENT.mind;
    const p = "--acc" + sideLetter;
    return p + ": " + a[0] + ";" + p + "Hi: " + a[1] + ";" + p + "Lo: " + a[2] + ";" +
      p + "Line: " + a[3] + ";" + p + "S22: " + a[0] + "38;";
  }

  function shortfall(deck) {
    const st = U.deckStats(deck);
    if (st.main !== 40) return st.main < 40 ? 40 - st.main + " cards missing" : st.main - 40 + " cards over";
    if (st.runes !== RUNE_TOTAL) return "rune deck " + st.runes + "/" + RUNE_TOTAL;
    if (st.field !== FIELD_TOTAL) return "battlefields " + st.field + "/" + FIELD_TOTAL;
    const errs = U.blockingErrs(deck);
    return errs.length ? errs[0] : "";
  }

  function blockSummary(who, deck) {
    if (!deck) return "No deck on " + (who === "Your" ? "your" : "the opponent's") + " side";
    const st = U.deckStats(deck);
    if (st.main !== 40) return who + " list is " + st.main + "/40";
    if (st.runes !== RUNE_TOTAL) return who + " rune deck is " + st.runes + "/" + RUNE_TOTAL;
    if (st.field !== FIELD_TOTAL) return who + " list has " + st.field + " of " + FIELD_TOTAL + " battlefields";
    const errs = U.blockingErrs(deck);
    return who + " list — " + (errs[0] || "not legal");
  }

  function curveRead(curve) {
    const bits = [curve.units + " units", curve.spells + " spells"];
    if (curve.gear) bits.push(curve.gear + " gear");
    bits.push("avg " + curve.avg.toFixed(1));
    return bits.join(" · ");
  }

  function heroBox(deck) {
    const legend = U.deckLegend(deck);
    const champ = U.deckChampion(deck);
    const errs = U.blockingErrs(deck);
    const hero = el("div", "plhero");
    if (legend || champ) hero.appendChild(U.artImg(legend || champ, "plheroart", { sizes: "620px" }));
    hero.appendChild(el("div", "plherofade"));
    if (errs.length) {
      const top = el("div", "plherotop");
      const flag = el("span", "plflag", "Incomplete");
      flag.title = errs.join(" · ");
      top.appendChild(flag);
      hero.appendChild(top);
    }
    const text = el("div", "plherotext");
    text.appendChild(el("span", "plheron", esc(deck.name)));
    text.appendChild(el("span", "plherosub", esc(legend ? legend.name : "no legend")));
    hero.appendChild(text);
    const champBox = el("div", "plherochamp");
    const art = el("span", "plherochampart");
    if (champ) art.appendChild(U.artImg(champ, "", { sizes: "80px" }));
    else art.className += " empty";
    art.title = champ ? champ.name : "no champion";
    champBox.appendChild(art);
    champBox.appendChild(el("span", "plherochampl", esc(champ ? champ.name.split(",")[0] : "no champion")));
    hero.appendChild(champBox);
    return hero;
  }

  function runeRow(deck) {
    const row = el("div", "plrrow");
    for (const dom of U.slots(U.runeList(deck, RUNE_TOTAL), RUNE_TOTAL)) {
      if (!dom) { row.appendChild(el("span", "plrune empty")); continue; }
      const card = U.runeCard(dom);
      const cell = el("span", "plrune");
      cell.title = dom;
      if (card) cell.appendChild(U.artImg(card, "", { sizes: "60px" }));
      row.appendChild(cell);
    }
    return row;
  }

  function fieldRow(deck) {
    const row = el("div", "plfrow");
    for (const id of U.slots(deck.battlefields || [], FIELD_TOTAL, FIELD_TOTAL)) {
      const card = id ? RB.Setup.findCard(id) : null;
      const cell = el("span", "plbf");
      const img = el("span", "plbfimg" + (card ? "" : " empty"));
      if (card) img.appendChild(U.artImg(card, "", { sizes: "200px" }));
      cell.appendChild(img);
      cell.appendChild(el("span", "plbfn" + (card ? "" : " empty"), esc(card ? card.name : "empty slot")));
      row.appendChild(cell);
    }
    return row;
  }

  function curveRow(deck) {
    const curve = deckCurve(deck);
    const errs = U.blockingErrs(deck);
    const peak = peakOf(curve.bars);
    const wrap = el("div", "plcrow");
    const bars = el("div", "plbars");
    for (let i = 0; i < CURVE_BARS; i++) {
      const n = curve.bars[i];
      const bar = el("span", "plbar");
      bar.title = (i === CURVE_BARS - 1 ? "7 or more energy" : i === 0 ? "1 energy or less" : i + 1 + " energy") +
        " · " + n + (n === 1 ? " card" : " cards");
      bar.appendChild(el("span", "plbarn", n ? String(n) : ""));
      const track = el("span", "plbart");
      const fill = el("span", "plbarf");
      fill.style.height = Math.round((n / peak) * 100) + "%";
      track.appendChild(fill);
      bar.appendChild(track);
      bar.appendChild(el("span", "plbarx", i === CURVE_BARS - 1 ? "7+" : String(i + 1)));
      bars.appendChild(bar);
    }
    wrap.appendChild(bars);
    const base = curveRead(curve);
    const read = el("div", "plcread" + (errs.length ? " bad" : ""),
      esc(errs.length ? shortfall(deck) + " · " + base : base));
    if (errs.length) read.title = errs.join(" · ");
    wrap.appendChild(read);
    return wrap;
  }

  function actionButton(label, ico, cls, onclick) {
    const b = el("button", "plabtn" + (cls ? " " + cls : ""), ico + "<span>" + esc(label) + "</span>");
    b.onclick = onclick;
    return b;
  }

  function deckActs(seat, cfg, title) {
    const deck = RB.Decklists.get(seat.deck);
    const acts = el("div", "placts");
    acts.appendChild(actionButton("Change deck", ICO.swap, "acc", function () {
      U.openDeckDrawer(seat === cfg.seats[0] ? "you" : "foe", title);
    }));
    if (deck) {
      acts.appendChild(actionButton("Edit list", ICO.pencil, "", function () { U.editDeck(deck); }));
    }
    return acts;
  }

  function deckStack(seat, cfg, title) {
    const frag = document.createDocumentFragment();
    const deck = RB.Decklists.get(seat.deck);
    if (!deck) {
      frag.appendChild(el("div", "plempty", "No deck on this seat yet."));
      frag.appendChild(deckActs(seat, cfg, title));
      return frag;
    }
    frag.appendChild(heroBox(deck));
    frag.appendChild(runeRow(deck));
    frag.appendChild(fieldRow(deck));
    frag.appendChild(curveRow(deck));
    frag.appendChild(deckActs(seat, cfg, title));
    return frag;
  }

  function rib(title, extra) {
    return U.lineRib("plrib", "plrib", title, extra);
  }

  function slbl(text) {
    const s = el("span", "plslbl", esc(text));
    s.appendChild(el("span", "plsline"));
    return s;
  }

  function nameInput() {
    const input = document.createElement("input");
    input.type = "text";
    input.className = "plrailname";
    input.id = "obnamefield";
    input.placeholder = "Unnamed";
    input.maxLength = 24;
    input.title = "The name your seat wears — online and agent tables need one";
    input.value = RB.Online.playerName();
    input.oninput = function () {
      const was = nameOk();
      RB.Online.setPlayerName(input.value);
      if (was === nameOk()) { nameEcho(); return; }
      APP.nameCaret = input.selectionStart;
      U.render();
    };
    return input;
  }

  function nameEcho() {
    const who = document.querySelector("#playscreen .plwhon.me");
    if (who) who.textContent = myName();
  }

  function restoreNameCaret() {
    if (APP.nameCaret === null || APP.nameCaret === undefined) return;
    const field = document.getElementById("obnamefield");
    const at = APP.nameCaret;
    APP.nameCaret = null;
    if (!field) return;
    field.focus();
    field.setSelectionRange(at, at);
  }

  function modeGrid(cfg, info) {
    const grid = el("div", "plmodes");
    for (const kind of U.FOES) {
      (function (kind) {
        const spec = MODES[kind];
        const tile = el("button", "plmode" + (cfg.foe === kind ? " on" : ""),
          "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'>" +
          "<path d='" + spec[2] + "'></path><path d='" + spec[3] + "'></path></svg>" +
          "<span>" + esc(spec[0]) + "</span>");
        tile.type = "button";
        tile.title = spec[1];
        if (kind === "native" && info && !info.native) {
          tile.className += " off";
          tile.title = "The native search player is not available on this server.";
        }
        if (kind === "claude" && lobbyInfo() && !lobbyInfo().agentSeats) {
          tile.className += " off";
          tile.title = "Agent seats are not enabled on this server.";
        }
        tile.onclick = function () {
          if (cfg.foe === kind) return;
          if (lobby().inLobby()) lobby().leave();
          cfg.foe = kind;
          saveMenuCfg(cfg);
          U.closeDeckDrawer();
          APP.ring = null;
          U.render();
        };
        grid.appendChild(tile);
      })(kind);
    }
    return grid;
  }

  function strengthSeg(cfg, info) {
    const seg = el("span", "plseg");
    for (const st of U.NATIVE_STRENGTHS) {
      (function (st) {
        const ms = info && info.presets && info.presets[st];
        const b = el("button", "plsegb" + (cfg.strength === st ? " on" : ""), esc(st.charAt(0).toUpperCase() + st.slice(1)));
        b.type = "button";
        b.title = ms ? "About " + (ms >= 1000 ? ms / 1000 + "s" : ms + "ms") + " of search per move" : "Search budget";
        b.onclick = function () {
          cfg.strength = st;
          saveMenuCfg(cfg);
          U.render();
        };
        seg.appendChild(b);
      })(st);
    }
    return seg;
  }

  function seatCard(seat, label, mine, myDeck) {
    const card = el("div", "plseatcard" + (seat && seat.ready ? " ready" : ""));
    const main = el("span", "plscmain");
    main.appendChild(el("span", "plscn", esc(seat ? seat.name : "Waiting…")));
    const deckLabel = !seat ? "empty seat"
      : mine && myDeck ? myDeck.name
        : seat.hasDeck ? "deck locked in" : "choosing a deck";
    main.appendChild(el("span", "plscd", esc(label + " · " + deckLabel)));
    card.appendChild(main);
    card.appendChild(el("span", "plscflag " + (seat && seat.ready ? "ok" : "bad"), seat ? (seat.ready ? "Ready" : "Not ready") : "—"));
    return card;
  }

  function copyRow(text, label) {
    const wrap = document.createDocumentFragment();
    wrap.appendChild(el("div", "plurl selectable", esc(text)));
    const acts = el("div", "placts");
    acts.appendChild(actionButton(label, ICO.copy, "acc", function () {
      if (navigator.clipboard) navigator.clipboard.writeText(text);
    }));
    wrap.appendChild(acts);
    return wrap;
  }

  function onlinePane(body, cfg) {
    const L = lobby();
    const pane = el("div", "pllob");
    if (!L.inLobby()) {
      pane.appendChild(slbl("Open tables"));
      const list = el("div", "pltables");
      if (!L.S.listed) list.appendChild(el("div", "plempty", "Looking for tables…"));
      else if (!L.S.list.length) list.appendChild(el("div", "plempty", "No open table right now — create one below."));
      for (const table of L.S.list) {
        (function (table) {
          const taken = table.seats.filter(function (s) { return s; }).length;
          const full = taken >= 2;
          const row = el("div", "pltrow" + (full ? " full" : ""));
          const meta = el("span", "pltmeta");
          meta.appendChild(el("span", "pltname", esc(table.name)));
          const who = table.seats.filter(function (s) { return s; }).map(function (s) {
            return s.name + (s.ready ? " (ready)" : "");
          }).join(" · ");
          meta.appendChild(el("span", "pltsub", esc((who || "empty") + " · Bo" + table.best + " · " + taken + "/2")));
          row.appendChild(meta);
          row.appendChild(el("span", "pltjoin", full ? "Full" : "Join"));
          if (!full && nameOk()) row.onclick = function () { L.enter(table.id); };
          else if (!full) row.title = "Type your name in the bar above first.";
          list.appendChild(row);
        })(table);
      }
      pane.appendChild(list);
      pane.appendChild(slbl("Or host"));
      const host = document.createElement("input");
      host.type = "text";
      host.className = "plnameinput";
      host.id = "oblobbyname";
      host.placeholder = "Table name (optional)";
      host.maxLength = 24;
      host.value = APP.lobbyName || "";
      host.oninput = function () { APP.lobbyName = host.value; };
      pane.appendChild(host);
      const acts = el("div", "placts");
      acts.appendChild(actionButton("Refresh list", "", "", function () { L.refreshList(); }));
      pane.appendChild(acts);
      body.appendChild(pane);
      return;
    }
    const me = L.mySeat();
    const other = L.other();
    const myDeck = RB.Decklists.get(cfg.seats[0].deck);
    pane.appendChild(slbl("Your table"));
    pane.appendChild(seatCard(other, me === 0 ? "Challenger" : "Host", false, null));
    if (me >= 0 && L.S.lobby) pane.appendChild(seatCard(L.S.lobby.seats[me], me === 0 ? "Host" : "Challenger", true, myDeck));
    if (me === 0 && !other) {
      pane.appendChild(slbl("Invite"));
      pane.appendChild(copyRow(location.origin + "/online/lobby/" + L.S.id, "Copy link"));
    }
    if (L.S.down) pane.appendChild(el("div", "plhint", "Reconnecting…"));
    const acts = el("div", "placts");
    acts.appendChild(actionButton("Leave table", "", "", function () { L.leave(); }));
    pane.appendChild(acts);
    body.appendChild(pane);
  }

  function claudePane(body, cfg) {
    const L = lobby();
    const pane = el("div", "pllob");
    if (!L.inLobby()) {
      pane.appendChild(slbl("Its deck"));
      const deck = RB.Decklists.get(cfg.seats[1].deck);
      pane.appendChild(deck ? U.deckRow(deck, { current: true }) : el("div", "plempty", "No deck on this seat yet."));
      const acts = el("div", "placts");
      acts.appendChild(actionButton("Change its deck", ICO.swap, "", function () {
        U.openDeckDrawer("foe", "Choose the opponent's deck");
      }));
      pane.appendChild(acts);
      pane.appendChild(el("div", "plhint", "Seating Claude opens a table for the two of you and gives you a seat URL to hand to Claude Code."));
      body.appendChild(pane);
      return;
    }
    const agent = L.S.agent;
    pane.appendChild(slbl("Claude's seat"));
    if (agent) {
      pane.appendChild(seatCard({ name: "Claude", ready: true, hasDeck: true }, esc(agent.deck), false, null));
      pane.appendChild(slbl("Seat URL"));
      pane.appendChild(copyRow(agent.url, "Copy seat URL"));
    } else {
      pane.appendChild(el("div", "plhint", L.S.busy ? "Seating Claude…" : "Claude has no seat yet."));
    }
    const acts = el("div", "placts");
    acts.appendChild(actionButton("Close table", "", "", function () { L.leave(); }));
    pane.appendChild(acts);
    body.appendChild(pane);
  }

  function seatShell(sideLetter, ringed) {
    const seat = el("div", "plseat " + sideLetter + (ringed ? " alert" : ""));
    const inner = el("div", "plseatin");
    seat.appendChild(inner);
    return { seat: seat, inner: inner };
  }

  function yourSeat(cfg) {
    const box = seatShell("l", APP.ring === "you");
    box.inner.appendChild(rib("Your side", botSeg(botMode(cfg) ? cfg.pilot : "you", true, function (v) {
      cfg.pilot = v;
      if (lobby().inLobby()) lobby().leave();
      APP.arenaLaunch = null;
      saveMenuCfg(cfg);
      U.render();
    })));
    const body = el("div", "plbody");
    const pilot = el("div", "plpilot");
    const who = el("div", "plwho");
    who.appendChild(el("span", "plwhon me", esc(myName())));
    who.appendChild(el("span", "plwhotag", "Human pilot"));
    pilot.appendChild(botMode(cfg) ? botWho(cfg.pilot) : who);
    if (usesClaude(cfg.pilot)) pilot.appendChild(modelSeg(modelOf(cfg.pilotModel), function (m) { cfg.pilotModel = m; saveMenuCfg(cfg); U.render(); }));
    body.appendChild(pilot);
    body.appendChild(deckStack(cfg.seats[0], cfg, "Choose your deck"));
    box.inner.appendChild(body);
    if (U.deckDrawerOpen("you")) box.inner.appendChild(U.deckDrawer("you", cfg));
    return box.seat;
  }

  function foeSeat(cfg, info) {
    const box = seatShell("r", APP.ring === "foe");
    const bots = botMode(cfg);
    box.inner.appendChild(rib("Opponent", bots
      ? botSeg(foePower(cfg), false, function (v) { cfg.foeBot = v; APP.arenaLaunch = null; saveMenuCfg(cfg); U.render(); })
      : cfg.foe === "native" ? strengthSeg(cfg, info) : null));
    const body = el("div", "plbody");
    const pilot = el("div", "plpilot");
    if (bots) {
      pilot.appendChild(botWho(foePower(cfg)));
      if (usesClaude(foePower(cfg))) pilot.appendChild(modelSeg(modelOf(cfg.foeModel), function (m) { cfg.foeModel = m; saveMenuCfg(cfg); U.render(); }));
    } else {
      pilot.appendChild(modeGrid(cfg, info));
    }
    body.appendChild(pilot);
    if (bots) {
      body.appendChild(deckStack(cfg.seats[1], cfg, "Choose the opponent's deck"));
    } else if (isLocal(cfg)) {
      if (cfg.foe === "native" && info && !info.native) {
        body.appendChild(el("div", "plhint bad", "The native search player is not available on this server."));
      }
      body.appendChild(deckStack(cfg.seats[1], cfg, "Choose the opponent's deck"));
    } else if (cfg.foe === "claude") claudePane(body, cfg);
    else onlinePane(body, cfg);
    box.inner.appendChild(body);
    if (U.deckDrawerOpen("foe")) box.inner.appendChild(U.deckDrawer("foe", cfg));
    return box.seat;
  }

  function spine(cfg, local) {
    const col = el("div", "plspine" + (local ? "" : " dim"));
    col.appendChild(el("div", "plsphead"));
    const body = el("div", "plspbody");
    const seam = el("div", "plspseam", "<i class='l'></i><i class='r'></i>");
    body.appendChild(seam);

    const pilot = el("div", "plsprow r-pilot");
    const badge = el("span", "plvsbadge", "Bo" + cfg.best);
    badge.title = cfg.best === 1 ? "One game" : "First to " + RB.Match.needed(cfg.best) + " games";
    pilot.appendChild(badge);
    body.appendChild(pilot);

    const hero = el("div", "plsprow r-hero");
    hero.appendChild(el("span", "plvsmark", "VS"));
    if (cfg.best === 1 && local) {
      const key = cfg.first === "you" ? ["you", ICO.openYou, "Opens"]
        : cfg.first === "foe" ? ["foe", ICO.openFoe, "Opens"]
          : ["roll", ICO.dice, "Roll"];
      const open = el("span", "plvsopen " + key[0], key[1] + "<span>" + key[2] + "</span>");
      open.title = key[0] === "roll"
        ? "Both seats roll a die; the higher roll takes the first turn (CR 485, TR 407.2)"
        : (key[0] === "you" ? "You" : "The opponent") + " takes the first turn";
      hero.appendChild(open);
    } else {
      const open = el("span", "plvsopen roll", ICO.dice + "<span>Roll</span>");
      open.title = cfg.best > 1
        ? "Game 1 rolls off; from game 2 the loser of the previous game chooses (TR 407.1, 407.4)"
        : "The table rolls for the first turn (CR 485, TR 407.2)";
      hero.appendChild(open);
    }
    body.appendChild(hero);

    for (const row of [["r-runes", "Runes"], ["r-fields", "Fields"], ["r-curve", "Curve"]]) {
      const r = el("div", "plsprow " + row[0]);
      r.appendChild(el("span", "plsplbl", esc(row[1])));
      body.appendChild(r);
    }
    body.appendChild(el("div", "plsprow r-acts"));
    col.appendChild(body);
    return col;
  }

  function segButton(label, on, dead, title, onclick) {
    const b = el("button", "plfbtn" + (on ? " on" : "") + (dead ? " dead" : ""), label);
    b.type = "button";
    if (title) b.title = title;
    if (!dead) b.onclick = onclick;
    return b;
  }

  function startLocal(cfg) {
    const you = RB.Decklists.get(cfg.seats[0].deck);
    const foe = RB.Decklists.get(cfg.seats[1].deck);
    if (!you || !foe) return;
    const opts = {
      best: cfg.best,
      decks: [you, foe],
      names: [null, null],
      ai: [cfg.seats[0].ai, cfg.seats[1].ai],
    };
    if (cfg.best === 1 && cfg.first !== "roll") opts.choose = cfg.first === "you" ? 0 : 1;
    const match = RB.Match.create(opts);
    if (!match) return;
    U.startMatch(match);
  }

  function launchPlan(cfg) {
    const L = lobby();
    const you = RB.Decklists.get(cfg.seats[0].deck);
    const foe = RB.Decklists.get(cfg.seats[1].deck);
    const local = isLocal(cfg);
    const needFoe = local || (cfg.foe === "claude" && !L.inLobby());
    const blockYou = U.blockingErrs(you);
    const blockFoe = needFoe ? U.blockingErrs(foe) : [];
    const plan = { label: "Start", action: null, disabled: false, block: null, detail: null, fix: null, ring: null };

    if (blockYou.length) {
      plan.block = blockSummary("Your", you);
      plan.detail = blockYou.join(" · ");
      plan.fix = "Choose another list";
      plan.ring = "you";
    } else if (blockFoe.length) {
      plan.block = blockSummary("The opponent's", foe);
      plan.detail = blockFoe.join(" · ");
      plan.fix = "Choose another list";
      plan.ring = "foe";
    }

    if (botMode(cfg)) {
      const launch = APP.arenaLaunch || {};
      const running = launch.busy ? null : arenaJob();
      if (running) {
        plan.label = "Watch the running game";
        plan.disabled = !!running.stopping;
        if (!plan.block) {
          plan.block = running.stopping ? "Stopping both players and the game..." : "An arena game is already running: " + running.seats.join(" vs ");
          plan.detail = plan.block;
          plan.fix = running.stopping ? null : "Stop it";
          plan.ring = "arenastop";
        }
        plan.action = function () { location.href = "/watch?game=" + encodeURIComponent(running.gameId); };
      } else {
        plan.label = launch.busy ? "Starting..." : "Watch the game";
        plan.disabled = !!launch.busy;
        if (launch.err) { plan.block = launch.err; plan.detail = launch.err; }
        plan.action = function () { startArena(cfg); };
      }
    } else if (local) {
      const info = U.nativeInfo(function () { U.render(); });
      if (cfg.foe === "native" && info && !info.native) {
        plan.block = plan.block || "The native search player is not available on this server";
        plan.disabled = true;
      }
      plan.action = function () { startLocal(cfg); };
    } else if (cfg.foe === "claude") {
      if (!L.inLobby()) {
        plan.label = "Seat Claude";
        plan.disabled = L.S.busy || !nameOk();
        if (!nameOk()) { plan.block = "Type your name first"; plan.fix = "Name yourself"; plan.ring = "name"; }
        plan.action = function () { L.seatClaude(RB.Decklists.get(cfg.seats[1].deck), cfg.best); };
      } else {
        plan.label = L.iAmReady() ? "Launching…" : "Launch game";
        plan.disabled = !L.S.agent || !L.otherReady() || L.iAmReady();
        if (!L.S.agent) plan.block = "Claude has no seat yet";
        else if (!L.otherReady()) plan.block = "Waiting for Claude to take its seat";
        plan.action = function () { L.setReady(true, you); };
      }
    } else {
      if (!L.inLobby()) {
        plan.label = "Create table";
        plan.disabled = L.S.busy || !nameOk() || !!L.S.listErr;
        if (!nameOk()) { plan.block = "Type your name first"; plan.fix = "Name yourself"; plan.ring = "name"; }
        else if (L.S.listErr) plan.block = L.S.listErr;
        plan.action = function () { L.create(APP.lobbyName || "", cfg.best); };
      } else if (L.mySeat() === 0) {
        plan.label = L.iAmReady() ? "Launching…" : "Launch game";
        plan.disabled = !L.otherReady() || L.iAmReady();
        if (!L.otherReady()) plan.block = "The challenger must join and ready up first";
        plan.action = function () { L.setReady(true, you); };
      } else {
        plan.label = L.iAmReady() ? "Cancel ready" : "Ready up";
        plan.disabled = L.mySeat() < 0;
        plan.action = function () { L.setReady(!L.iAmReady(), you); };
      }
    }
    plan.off = plan.disabled || blockYou.length > 0 || blockFoe.length > 0;
    return plan;
  }

  function shortName(deck) {
    if (!deck) return "No deck";
    const dash = deck.name.indexOf(" \u2014 ");
    return dash > 0 ? deck.name.slice(0, dash) : deck.name;
  }

  function summaryFor(cfg) {
    const L = lobby();
    const left = shortName(RB.Decklists.get(cfg.seats[0].deck));
    let right;
    if (isLocal(cfg)) right = shortName(RB.Decklists.get(cfg.seats[1].deck));
    else if (cfg.foe === "claude") right = "Claude";
    else {
      const other = L.inLobby() ? L.other() : null;
      right = other ? other.name : "a challenger";
    }
    return [left, right];
  }

  function launchBar(cfg, plan) {
    const local = isLocal(cfg);
    const bar = el("div", "pllaunch");
    const inner = el("div", "pllaunchin");

    const fmt = el("div", "pllgrp fmt");
    fmt.appendChild(el("span", "pllglbl", "Format"));
    const fseg = el("span", "plfseg");
    for (const best of RB.Match.BESTS) {
      (function (best) {
        fseg.appendChild(segButton("Bo" + best, cfg.best === best, false,
          best === 1
            ? "One game, battlefields drawn at random (CR 485)"
            : "First to " + RB.Match.needed(best) + " games — present a battlefield each game, the loser picks who plays first, and from game 2 you may sideboard (CR 486, TR 403)",
          function () {
            cfg.best = best;
            saveMenuCfg(cfg);
            U.render();
          }));
      })(best);
    }
    fmt.appendChild(fseg);
    inner.appendChild(fmt);

    const who = el("div", "pllgrp who");
    who.appendChild(el("span", "pllglbl", "Who opens"));
    const oseg = el("span", "plfseg");
    const dead = cfg.best > 1 || !local;
    const deadWhy = cfg.best > 1
      ? "In a match the loser of each game chooses who plays first (TR 407.1, 407.4) — game 1 rolls off."
      : "Only a local table can be told who opens; an online or agent table rolls (CR 485).";
    for (const opt of [["you", "You"], ["roll", null], ["foe", "Opponent"]]) {
      (function (opt) {
        const label = opt[1] === null ? ICO.dice + "<span>Roll</span>" : opt[1];
        oseg.appendChild(segButton(label, !dead && cfg.first === opt[0], dead,
          dead ? deadWhy
            : opt[0] === "roll"
              ? "Both seats roll a die and the higher roll takes the first turn, as at a table (CR 485, TR 407.2)"
              : (opt[0] === "you" ? "You take" : "The opponent takes") + " the first turn — a local convenience that skips the roll",
          function () {
            cfg.first = opt[0];
            saveMenuCfg(cfg);
            U.render();
          }));
      })(opt);
    }
    who.appendChild(oseg);
    inner.appendChild(who);

    const sum = el("div", "pllsum");
    const pair = summaryFor(cfg);
    sum.appendChild(el("span", "pllsumt", esc(pair[0]) + "<em>VS</em>" + esc(pair[1])));
    if (plan.block) {
      const warn = el("button", "plwarn",
        ICO.warn + "<span>" + esc(plan.block) + "</span>" + (plan.fix ? "<u>" + esc(plan.fix) + "</u>" : ""));
      warn.type = "button";
      warn.title = plan.detail || plan.block;
      if (plan.ring === "name") {
        warn.onclick = function () {
          const field = document.getElementById("obnamefield");
          if (field) field.focus();
        };
      } else if (plan.ring === "arenastop") {
        warn.onclick = stopArena;
      } else if (plan.ring) {
        warn.onclick = function () {
          APP.ring = plan.ring;
          U.openDeckDrawer(plan.ring, plan.ring === "you" ? "Choose your deck" : "Choose the opponent's deck");
        };
      }
      sum.appendChild(warn);
    } else if (botMode(cfg)) {
      sum.appendChild(el("span", "pllsumhint", esc(ARENA_HINT)));
    }
    inner.appendChild(sum);

    const seal = ACCENT[accentKey(RB.Decklists.get(cfg.seats[0].deck))] || ACCENT.mind;
    const plate = el("button", "plplate" + (plan.off ? " off" : ""),
      "<span class='plplatefill'></span>" +
      "<span class='plplateseal'><svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.15'>" +
      "<path d='M12 1.9l8.7 5v10L12 21.9l-8.7-5v-10z'></path>" +
      "<path d='" + seal[4] + "' fill='currentColor' stroke='none'></path></svg></span>" +
      "<span class='plplatetext'><span class='plplatew'>" + esc(plan.label) + "</span>" +
      "<span class='plptrack'><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i></span>" +
      "<span class='plplatesub'>First to eight</span></span>" +
      "<span class='plplatego'>" + ICO.go + "</span>");
    plate.type = "button";
    plate.disabled = plan.off;
    if (plan.block) plate.title = plan.detail || plan.block;
    plate.onclick = function () { if (plan.action) plan.action(); };
    inner.appendChild(plate);

    bar.appendChild(inner);
    return { bar: bar, plate: plate };
  }

  function routePlay(cfg) {
    if (APP.playRouted) return;
    APP.playRouted = true;
    const m = location.pathname.match(/^\/online\/lobby\/([a-z0-9]+)$/i);
    if (m) {
      cfg.foe = "online";
      saveMenuCfg(cfg);
      RB.Online.Lobby.enter(m[1]);
    } else if (location.pathname === "/online") {
      cfg.foe = "online";
      saveMenuCfg(cfg);
      history.replaceState(null, "", "/play");
    } else if (location.pathname === "/local") {
      history.replaceState(null, "", "/play");
    }
  }

  function renderPlay() {
    const root = document.getElementById("app");
    root.innerHTML = "";
    root.className = "";
    const cfg = menuCfg();
    const L = lobby();
    L.onChange(function () { if (APP.screen === "menu" && APP.mode === "play") U.render(); });
    routePlay(cfg);
    const local = isLocal(cfg);
    if (!local) L.fetchInfo();
    L.watchList(cfg.foe === "online" && !L.inLobby());
    if (local && L.inLobby()) L.leave();
    const info = U.nativeInfo(function () { U.render(); });

    const wrap = el("div", "plui");
    wrap.id = "playscreen";
    const foeKey = local ? accentKey(RB.Decklists.get(cfg.seats[1].deck)) : REMOTE_ACCENT[cfg.foe];
    wrap.setAttribute("style", tint("L", accentKey(RB.Decklists.get(cfg.seats[0].deck))) + tint("R", foeKey));
    wrap.appendChild(el("div", "plaura"));
    wrap.appendChild(el("div", "plweave"));
    wrap.appendChild(el("div", "plvig"));

    const rail = el("div", "plrail");
    rail.appendChild(el("div", "plhair"));
    const back = el("button", "plback", ICO.back + "<span>Menu</span>");
    back.type = "button";
    back.onclick = function () { location.href = "/"; };
    rail.appendChild(back);
    const mark = el("div", "plmark", ICO.seal +
      "<span class='plmarkt'><span class='plmarkw'>PLAY</span>" +
      "<span class='plmarksub'>Standard 1v1 · first to eight</span></span>");
    rail.appendChild(mark);
    const railr = el("div", "plrailr");
    railr.appendChild(nameInput());
    const builder = el("button", "plhb", ICO.book + "<span>Deckbuilder</span>");
    builder.type = "button";
    builder.title = "Create and edit the decks stored in this browser";
    builder.onclick = function () { location.href = U.DECK_LIST_PATH; };
    railr.appendChild(builder);
    rail.appendChild(railr);
    wrap.appendChild(rail);

    const err = APP.error || L.S.err;
    if (err) wrap.appendChild(el("div", "plerr", "⚠ " + esc(err)));

    const table = el("div", "pltable");
    table.appendChild(yourSeat(cfg));
    table.appendChild(spine(cfg, local));
    table.appendChild(foeSeat(cfg, info));
    wrap.appendChild(table);

    const plan = launchPlan(cfg);
    const launch = launchBar(cfg, plan);
    wrap.appendChild(launch.bar);
    root.appendChild(wrap);

    restoreNameCaret();
    U.restoreDeckDrawer();

    let autostart = null;
    let intent = null;
    try {
      autostart = localStorage.getItem(TRAINER_START_KEY);
      if (autostart) localStorage.removeItem(TRAINER_START_KEY);
      intent = localStorage.getItem(U.HOME_INTENT_KEY);
      if (intent) localStorage.removeItem(U.HOME_INTENT_KEY);
    } catch (e) { }
    if (autostart && !plan.off && local) setTimeout(function () { launch.plate.onclick(); }, 0);
    else if (intent && intent === cfg.foe && !local && !L.inLobby() && !plan.off) {
      setTimeout(function () { launch.plate.onclick(); }, 0);
    } else if (intent && intent === cfg.foe && !local && !nameOk()) {
      const field = document.getElementById("obnamefield");
      if (field) field.focus();
    }
  }

  Object.assign(U, { renderPlay: renderPlay });
})();
